import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import ServiceIntro from '../../components/ServiceIntro/ServiceIntro';
import ProductList from '../../components/ProductList/ProductList';
import productsData from '../../data/products.json';

const investmentContent = {
  subtitle: "软件解决方案",
  title: "投资与风险管理",
  description: [
    "投资之道，稳健为先。我们的投资与风险管理方案致力于帮助企业和投资者精准洞察市场变化，定制个性化投资策略，并构建完善的风险防控体系，守护资产安全与价值增长。",
    "向下滑动，详细了解我们的专业产品组合，让您的每一步决策都有数据支持、风险可控。",
  ],
  image: "/images/solutions/touzi.png"
};

const investmentProducts = {
  title: "我们的产品",
  subtitle: "投资管理解决方案",
  products: productsData.stockProducts
};

const Investment = () => {
  return (
    <div className="investment-page flex flex-col min-h-screen">
      <Navbar />
      <ServiceIntro {...investmentContent} />
      <div style={{ backgroundColor: '#f8f9fa' }}>
      <ProductList {...investmentProducts} />
      </div>
      <div className='mt-auto'  style={{backgroundColor: '#f8f9fa'}}>
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default Investment; 